<template>
	<el-main class="info-wrap">
		<div class="info-box">
			<div>
				<div class="info-head tc">
					<h3 class="info-title">图书销售协议</h3>
				</div>
				<div class="info-content-xieyi" v-html="infoText"></div>
			</div>
		</div>
	</el-main>
</template>

<script>
export default {
	data() {
		return {
			infoText: `<h2>[特规通-正版法规标准及图书购买协议]</h2><p>生效日期：2026年03月01日</p><p>甲方（销售方）：北京品读文化有限公司</p><p>乙方（购买方）：通过“特规通”平台下单并完成支付的自然人、法人或其他组织</p><p>丙方（平台方）：量大（北京）信息科技研究院有限公司，即“特规通”平台运营方，仅为交易提供网络经营场所、商品展示、交易撮合、在线支付通道接入、订单管理、信息发布、技术支持等平台服务，不作为商品销售方或出版方</p><p>重要提示：请您在购买商品前仔细阅读本协议全部条款，尤其是关于商品交付、退换规则、电子商品特殊规则、知识产权限制、个人信息保护、免责及争议解决等内容。乙方在“特规通”平台勾选“我已阅读并同意《正版法规标准及图书购买协议》”并提交订单、完成支付后，即视为乙方已充分阅读、理解并接受本协议全部内容。本协议即在乙方与甲方之间成立并生效；丙方作为平台服务提供方，依本协议约定承担相应的平台服务义务。</p><p>一、定义与适用范围</p><p>1.1 本协议所称“商品”，是指甲方委托丙方通过“特规通”平台展示并销售的国家标准、行业标准、地方标准、团体标准、法规汇编、配套解读、合订本、纸质图书、电子文档及其他相关正版出版物或文件资料。</p><p>1.2 根据交付形式不同，商品分为：</p><p>（1）纸质商品：指以纸质图书、纸质标准文本、纸质汇编等形式交付的商品；</p><p>（2）电子商品：指以PDF或其他可阅读数字格式交付的电子版标准、法规、图书或其他数字内容。</p><p>1.3 本协议适用于乙方通过“特规通”平台购买前述商品的全部交易行为。乙方在平台就单笔订单完成支付后，该笔订单即适用本协议以及平台公示的相关交易规则、售后规则、发票规则、隐私规则等。</p><p>二、交易主体与平台角色</p><p>2.1 甲方系商品的实际销售方、开票方及售后责任主体。甲方确认其已依法取得所售商品的相应发行权、销售权、授权或其他合法经营资格，并有权委托丙方通过平台进行展示、销售与订单管理。</p><p>2.2 乙方下单并完成支付后，就所购商品与甲方建立买卖合同关系。与商品销售、交付、质量、发票、售后、退款、退换货等相关的权利义务，除本协议另有约定外，原则上由甲方承担。</p><p>2.3 丙方仅提供平台技术服务和交易辅助服务，包括但不限于商品展示、订单生成、在线支付技术接入、信息通知、订单管理、客户咨询转接及平台规则管理等。丙方不是商品销售方、出版方或知识产权权利人；除法律法规另有规定外，丙方不对甲方商品本身的内容准确性、适用性、合法性、版本更新情况或售后结果承担销售方责任。</p><p>2.4 纸质商品的发货、物流协调、退换货处理及与纸质商品相关的售后服务，由甲方负责；丙方可根据平台规则提供必要的协助、转达和协调服务。</p><p>三、商品信息、下单与合同成立</p><p>3.1 甲方应对商品名称、标准编号、版本信息、发布日期、实施状态、替代关系、交付形式、价格、库存状态、是否电子版或纸质版等商品信息尽合理说明义务；但因标准、法规、图书本身可能存在修订、替代、废止、重印、再版等情形，乙方应在购买前自行核对并确认所需商品信息。</p><p>3.2 乙方应在下单前仔细核对商品名称、标准编号、版本、格式、页数、交付方式、价格、数量及适用需求。因乙方未审慎核对而产生的误购、重复购买、不适用等风险，由乙方自行承担，但法律法规另有强制性规定的除外。</p><p>3.3 乙方在平台提交订单并完成支付后，视为向甲方发出购买要约；甲方或平台系统确认收款并生成有效订单后，该笔交易成立。除法律法规另有规定或甲方另有明确承诺外，订单成立后，乙方不得无故取消已经完成支付的订单；但纸质商品在发货前，可按照本协议约定申请退款。</p><p>3.4 如因库存不足、授权变化、商品下架、价格标示明显错误、系统异常、不可抗力或其他非甲方主观故意原因导致订单无法履行，甲方有权取消订单并退还乙方已支付款项；丙方应协助完成订单关闭及退款流程。</p><p>四、价款、支付与发票</p><p>4.1 商品价格以乙方提交订单时“特规通”平台订单页面显示的价格为准。除页面另有明确说明外，商品价格为含税价格，不含乙方自行选择的加急配送费、保价费或其他增值服务费用。</p><p>4.2 乙方可根据平台提供的支付方式完成付款，包括但不限于微信支付、支付宝支付、对公转账或平台届时支持的其他合法支付方式。乙方应在订单规定时限内完成付款；逾期未付款的，订单可由平台自动关闭。</p><p>4.3 丙方可根据甲方委托代收货款，并按照双方结算安排与甲方结算。乙方理解并同意，丙方代收货款不改变甲方作为销售方的法律地位。</p><p>4.4 本协议项下纸质商品和电子商品的销售发票，均由甲方北京品读文化有限公司依法开具。</p><p>4.5 发票形式原则上为电子发票，乙方可按订单页面或平台规则申请开票并自行下载。发票开具内容按照税务管理要求及甲方开票系统规则执行，发票类型为图书相关发票或税务机关允许的相应图书类发票内容。</p><p>4.6 乙方应准确填写发票抬头、纳税人识别号、接收邮箱等开票信息。因乙方填写错误、信息不完整或申请开票时间延误导致的发票开具失败、重开困难、税务处理障碍等后果，由乙方自行承担；甲方在符合法律法规和税务规则前提下予以合理协助。</p><p>五、交付方式与交付完成标准</p><p>5.1 纸质商品交付</p><p>（1）甲方负责安排纸质商品出库、打包并交付第三方物流承运；</p><p>（2）纸质商品的预计发货时间、物流时效以商品页面、订单页面、物流公司规则及实际履约情况为准；</p><p>（3）纸质商品自物流信息显示“已签收”之时，视为甲方已完成交付；如乙方指定代收人、收发室、前台、门卫、驿站、快递柜或其他第三方代为接收的，相关签收亦视为乙方签收；</p><p>（4）乙方应确保收货人姓名、联系电话、收货地址真实、准确、完整。因乙方提供信息错误、无人签收、拒收、地址无法送达等原因导致延迟交付、退回、额外运费或商品损失的，由乙方承担相应责任和费用，但因甲方原因导致的除外。</p><p>5.2 电子商品交付</p><p>（1）电子商品可通过平台下载链接、站内阅读权限、提取码、邮件附件、其他数字交付方式等进行交付，具体以商品页面及订单页面展示为准；</p><p>（2）电子商品设置购买者水印、文件密码保护、账户绑定、阅读权限控制或其他合理技术保护措施的，属于正常交付及版权保护方式；</p><p>（3）当甲方或丙方已向乙方提供下载链接、阅读权限、提取码、邮件附件或其他可正常接收、下载、读取电子商品的条件时，即视为电子商品已完成交付；</p><p>（4）乙方应自行确保其接收邮箱、设备环境、阅读软件及网络条件满足电子商品接收和使用要求。</p><p>5.3 风险转移</p><p>（1）纸质商品的毁损、灭失风险，自乙方或其指定收货人签收时起转移至乙方；</p><p>（2）电子商品不存在适用传统物流运输风险转移规则的情形，其交付完成后因乙方设备故障、密码遗失、邮箱错误、网络限制、文件保存不当等原因造成无法再次使用的风险，由乙方自行承担，但因甲方或丙方系统原因导致的除外。</p><p>六、退款、退货与换货规则</p><p>6.1 纸质商品发货前退款</p><p>纸质商品在甲方实际发货前，乙方可通过平台订单页面或联系客服申请退款。经审核确认商品尚未发货的，甲方应同意取消订单并安排退款。退款原则上按原支付路径退回，到账时间以支付机构、银行或相关支付渠道实际处理时间为准。</p><p>6.2 纸质商品发货后退换规则</p><p>6.2.1 纸质商品发货后，除法律法规另有强制性规定外，原则上不支持无理由退货或换货。</p><p>6.2.2 如乙方收到的纸质商品存在下列情形之一，乙方可在签收后7日内通过平台申请售后，并提交必要证明材料：</p><p>（1）甲方发错货；</p><p>（2）商品存在严重印刷质量问题，如缺页、倒装、散页、严重污损、严重裁切错误等影响正常阅读或使用的质量问题；</p><p>（3）纸质商品在运输过程中发生严重破损，且能够证明并非乙方原因所致；</p><p>（4）法律法规规定或甲方承诺可以退换的其他情形。</p><p>6.2.3 乙方申请纸质商品退换货时，应提供订单编号、收货人信息、问题描述及清晰照片、视频等证明材料。甲方有权对售后申请进行审核，并根据审核结果决定退款、换货、补发或其他合理处理方式。</p><p>6.2.4 经核实属于甲方责任或商品质量问题的，甲方负责承担合理的退换货运费；不属于甲方责任或不属于可退换情形的，甲方有权拒绝退换申请，由此产生的相关费用由乙方承担。</p><p>6.2.5 有下列情形之一的，甲方有权不予退换：</p><p>（1）超过本协议约定时限提出售后申请；</p><p>（2）因乙方或第三方原因造成商品污损、折损、浸水、涂写、拆解、毁损；</p><p>（3）乙方提交的商品并非甲方销售商品；</p><p>（4）乙方无法提供必要订单信息或合理证明材料；</p><p>（5）发票已完成报销、抵扣且依法无法作废，导致退款处理客观上存在障碍的，但法律法规另有规定的除外；</p><p>（6）其他不符合法律法规、本协议或平台规则约定的情形。</p><p>6.3 电子商品退款与售后规则</p><p>6.3.1 电子商品属于数字化商品，具有可复制、可传播的特性。乙方在支付成功后，原则上不得以误购、重复购买、版本不符、个人需求变化、不适用、未仔细核对商品信息等理由要求退款、退货或换货。</p><p>6.3.2 电子商品一经交付完成，原则上不支持退换。但如电子商品存在文件损坏、无法打开、内容明显缺失、授权文件与订单严重不符、密码错误且无法修复等质量问题，乙方可联系客服申请处理。</p><p>6.3.3 对于经核实存在质量问题的电子商品，甲方可视具体情况采取重新发送、重新授权、修复文件、补充完整文件、变更可正常使用的交付方式等处理措施；如确无法修复或重新交付的，按照法律法规、平台规则及双方协商结果处理。</p><p>6.3.4 乙方不得以已付款但未主动下载、未查看邮件、未及时保存文件、设备不兼容、阅读环境问题或第三方软件限制等非甲方责任原因主张电子商品退换或赔偿，但因甲方或丙方系统原因导致无法交付的除外。</p><p>七、知识产权与使用限制</p><p>7.1 甲方所售商品，尤其是电子商品，受著作权及相关法律法规保护，其著作权、信息网络传播权、发行权及其他权利归原权利人、出版机构或相关授权方所有。</p><p>7.2 乙方购买电子商品后，仅获得一份在合法范围内由本人或本单位内部使用的非专属、不可转让、不可转授权的使用权。除法律法规另有明确规定外，乙方不得将电子商品用于任何未经授权的传播、转授权或商业用途。</p><p>7.3 乙方不得实施以下行为：</p><p>（1）复制、翻印、扫描、出售、出租、出借、转授权、转售电子商品；</p><p>（2）上传至互联网、网盘、社群、论坛、公众号、内部共享平台或其他任何公开或半公开渠道；</p><p>（3）以截图、录屏、打印、二次编辑、技术破解、去除水印、破解密码、绕过访问控制等方式规避甲方或授权方设置的版权保护措施；</p><p>（4）将电子商品用于培训售卖、商业数据库建设、商业咨询、收费传播、再出版或其他商业利用；</p><p>（5）实施其他侵犯著作权人、发行权人、授权方合法权益的行为。</p><p>7.4 甲方有权对电子商品采取购买者姓名、账号、订单号、单位名称、手机号部分字段或其他可识别信息形式的水印标识、加密措施及密码保护。乙方不得擅自删除、篡改或规避前述保护措施。</p><p>7.5 如乙方违反本条约定，甲方及相关权利人有权要求乙方立即停止侵权、删除或销毁侵权复制件、消除影响，并赔偿因此造成的全部损失，包括但不限于直接损失、合理维权费用、律师费、公证费、诉讼费、保全费、鉴定费、差旅费及商誉损失等。</p><p>八、个人信息保护</p><p>8.1 为完成订单生成、支付结算、商品交付、物流配送、开具发票、售后服务、争议处理、客服支持及平台安全保障之目的，甲方和丙方可依法收集、使用乙方的姓名、联系方式、收货地址、邮箱、订单信息、开票信息、支付状态等必要信息。</p><p>8.2 甲方和丙方将按照各自适用的隐私政策及相关法律法规处理乙方个人信息，并采取合理安全措施保护乙方个人信息安全。</p><p>8.3 除为实现本协议目的所必要的物流、支付、电子发票、客服、技术服务等合作方处理，或依据法律法规、有权机关要求外，甲方和丙方不会非法出售、泄露或向无关第三方提供乙方个人信息。</p><p>8.4 乙方同意，为完成纸质商品发货及售后处理，丙方可将乙方订单信息及必要收货信息传递给甲方；为完成支付、物流、发票和通知服务，甲方或丙方可向相应服务商提供必要信息。</p><p>九、声明、保证与免责</p><p>9.1 甲方声明并保证，其对所售商品具有合法销售资格或授权，并依法承担销售方义务。</p><p>9.2 乙方声明并保证，其购买、使用商品的行为不违反法律法规，不侵犯第三方合法权益；如乙方以单位名义购买，乙方应保证下单人员已获得相应授权。</p><p>9.3 丙方作为平台方，已就平台内交易提供必要的技术支持、订单管理和信息展示服务。除法律法规另有规定外，丙方不因甲方商品内容、版本状态、授权范围、印刷质量、物流时效、售后处理结果而承担销售方责任，但丙方应在合理范围内提供协调协助。</p><p>9.4 因下列原因导致迟延履行、无法履行或履行瑕疵的，相关责任方在法律允许范围内不承担违约责任，但应及时采取合理补救措施：</p><p>（1）不可抗力，包括自然灾害、火灾、洪水、战争、政府行为、重大公共卫生事件、电信故障、黑客攻击、系统故障、停电等；</p><p>（2）第三方支付机构、物流服务商、邮件服务商、云服务商等外部服务异常；</p><p>（3）乙方填写信息错误、拒收、逾期未配合、设备环境不满足要求、邮箱拦截、网络限制等乙方原因；</p><p>（4）商品版权方、出版社、授权方调整授权范围、停止供货、变更版本、终止发行等非甲方可控制情形。</p><p>9.5 甲方和丙方对商品内容是否完全符合乙方特定用途、内部制度、项目要求或其他个性化需求，不作明示或默示保证。乙方应自行判断所购商品是否满足其使用目的。</p><p>十、违约责任</p><p>10.1 任何一方违反本协议约定，给其他方造成损失的，应依法承担相应违约责任。</p><p>10.2 因甲方原因导致商品无法交付、交付错误、存在应由甲方承担的质量问题或应退款情形的，甲方应按照本协议约定及时履行补发、更换、修复、退款等义务。</p><p>10.3 因乙方违反知识产权、使用限制、支付义务、诚信交易义务或提供虚假信息等行为给甲方、丙方或第三方造成损失的，乙方应承担赔偿责任。</p><p>10.4 因丙方平台系统故障、信息处理错误或其他可归责于丙方的原因，导致订单管理、支付通知、下载交付等环节出现错误并给乙方或甲方造成直接损失的，丙方应在其过错范围内承担相应责任；但丙方责任不当然扩展为商品销售责任或版权担保责任。</p><p>十一、协议生效、变更与终止</p><p>11.1 本协议自2026年03月01日起施行。</p><p>11.2 就具体订单而言，本协议于乙方在“特规通”平台提交订单并完成支付时，对该笔订单对应的甲乙双方生效；丙方作为平台服务提供方，依据本协议相应条款参与该笔交易过程。</p><p>11.3 甲方和丙方有权根据法律法规变化、监管要求、业务调整或平台规则更新对本协议进行修订，并通过平台页面公示。修订后的协议自公示载明的生效日期起生效。乙方在修订后继续通过平台购买商品的，视为接受修订后的协议。</p><p>11.4 本协议因单笔订单履行完毕而终止，但与知识产权、个人信息保护、违约责任、争议解决、送达等性质上应持续有效的条款不因订单履行完毕而失效。</p><p>十二、通知与送达</p><p>12.1 与本协议或订单有关的通知、提醒、催告、售后回复、系统消息等，甲方或丙方可通过站内信、短信、电子邮件、电话、即时通信工具、订单页面通知、平台公告等方式向乙方发送。</p><p>12.2 前述通知自发送至乙方在订单或账户中预留的联系方式、账号或通知页面时，视为已送达；因乙方联系方式错误、停机、邮箱失效、拒收、未及时查看等原因导致未实际接收的，不影响送达效力。</p><p>12.3 乙方如需联系甲方或丙方，可通过平台在线客服或以下方式：</p><p>客服电话：18911620150<br>客服邮箱：service@teguitong.com<br>联系地址：北京市朝阳区胜古中路2号院8号楼企发大厦817室</p><p>十三、争议解决</p><p>13.1 本协议的订立、效力、履行、解释及争议解决，适用中华人民共和国法律。</p><p>13.2 因本协议或相关订单产生的任何争议，各方应先行友好协商解决；协商不成的，任何一方均有权向甲方住所地有管辖权的人民法院提起诉讼。</p><p>十四、其他</p><p>14.1 本协议构成甲乙双方就平台单笔商品交易达成的完整交易约定；平台已公示的商品详情页、订单页面、售后规则、发票规则、隐私政策、用户协议等，与本协议共同构成交易规则体系。相关规则与本协议不一致的，就具体事项以最新公示且与该事项最直接相关的规则为准；但法律法规另有规定的除外。</p><p>14.2 本协议中标题仅为阅读方便而设，不影响条款含义、解释及法律效力。</p><p>14.3 如本协议任何条款被认定为无效、违法或不可执行，不影响本协议其他条款的有效性和可执行性。</p><p>北京品读文化有限公司</p><p>量大（北京）信息科技研究院有限公司</p><p>2026年03月01日</p>`
		};
	}
};
</script>

<style lang="less" scoped>
/deep/ .info-content-xieyi ul {
	list-style: none !important;
    padding: 0;
}

/deep/ .info-content-xieyi li {
	list-style: none !important;
}
.info-wrap {
	margin-left: 20px;
	padding: 20px 0 !important;
	font-size: 14px;
	// color: #475569;
	line-height: 1.8;
	background-color: #fff;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
	border-radius: 12px;
	 min-height: calc(100vh - 120px);

	.info-title {
		margin: 0 0 10px;
		font-weight: 600;
		font-size: 24px;
		color: #334155;
	}
}

.info-item {
	margin-bottom: 20px;
}

.info-head {
	margin-bottom: 25px;
	padding-bottom: 15px;
	border-bottom: 1px dashed #e2e8f0;

	.topbox {
		color: #94a3b8;

		dd {
			margin: 0 30px 0 0;
		}
	}
}
</style>

<style lang="less">
.info-content-xieyi {
	// text-indent: 2em;
	padding: 0 30px;
}

.info-content-xieyi ul {
	// list-style: none !important;
	// padding: 0;
}

.info-content-xieyi li {
	// list-style: none !important;
}

.info-content-xieyi p {
	line-height: 30px;
	margin: 0;
}

.info-content-xieyi h5 {
	color: #0f172a;
	font-size: 16px;
	margin: 0;
	padding: 0;
	line-height: 34px;
	margin-top: 10px;
}

.info-content-xieyi h6 {
	color: #0f172a;
	font-size: 16px;
	margin: 0;
	padding: 0;
	line-height: 34px;
	position: relative;
}

.info-content-xieyi h6:before {
	content: ' ';
	display: inline-block;
	width: 5px;
	height: 5px;
	background: #155dfc;
	border-radius: 50%;
	margin-right: 10px;
	position: absolute;
	top: 16px;
	left: 18px;
}

.info-box {
	padding-bottom: 30px;
}
</style>